import * as actionTypes from "../../constants/actionTypes";
import {
  getPhoneVariant,
  getPhoneVariantIds,
  getPhoneVariants
} from "../../api/phoneVariant";
import { OFFER_TYPES } from "../../constants/offerTypes";

const invalidatePhoneVariants = () => {
  return {
    type: actionTypes.INVALIDATE_PHONE_VARIANTS_DATA
  };
};

const loadPhoneVariant = (clientConfig, phoneVariantId) => {
  return {
    type: actionTypes.LOAD_PHONE_VARIANT_DATA,
    promise: getPhoneVariant(clientConfig, phoneVariantId)
  };
};

const loadPhoneVariantPhoneOfferIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_VARIANT_PHONE_OFFER_IDS_DATA,
    promise: getPhoneVariantIds(
      clientConfig,
      OFFER_TYPES.phoneOffer,
      dataStatus
    )
  };
};

const loadPhoneVariantPropositionIds = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_VARIANT_PROPOSITION_IDS_DATA,
    promise: getPhoneVariantIds(
      clientConfig,
      OFFER_TYPES.proposition,
      dataStatus
    )
  };
};

const loadPhoneVariants = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_PHONE_VARIANTS_DATA,
    promise: getPhoneVariants(clientConfig, dataStatus)
  };
};

export {
  invalidatePhoneVariants,
  loadPhoneVariant,
  loadPhoneVariantPhoneOfferIds,
  loadPhoneVariantPropositionIds,
  loadPhoneVariants
};
